import { render, staticRenderFns } from "./BookingSpecial.vue?vue&type=template&id=f9f34ad2&scoped=true"
import script from "./BookingSpecial.vue?vue&type=script&lang=ts"
export * from "./BookingSpecial.vue?vue&type=script&lang=ts"
import style0 from "./BookingSpecial.vue?vue&type=style&index=0&id=f9f34ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f34ad2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsFormResponse: require('/usr/src/nuxt-app/components/elements/FormResponse.vue').default,ElementsInputWithValidation: require('/usr/src/nuxt-app/components/elements/InputWithValidation.vue').default,ElementsPrivacyCheckbox: require('/usr/src/nuxt-app/components/elements/PrivacyCheckbox.vue').default})
